import React from "react";

const TemarioDiplomaturaIAMedica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Historia de la inteligencia artificial y estado actual de la tecnología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Historia de la IA"}</span></li>
                <li><span className="fw-light">{"Estado actual de la IA y sus alcances actuales"}</span></li>
                <li><span className="fw-light">{"Problemáticas actuales de la salud e IA como probable solución"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fundamentos de la inteligencia artificial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la IA y sus fundamentos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Datos e inteligencia artificial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Importancia de los datos en IA"}</span></li>
                <li><span className="fw-light">{"Tipos de datos"}</span></li>
                <li><span className="fw-light">{"Bases de datos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Machine learning y deep learning"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición y fundamentos del Machine Learning"}</span></li>
                <li><span className="fw-light">{"Definición y fundamentos del Deep Learning"}</span></li>
            </ul>
            <br /><br />
            <b>{"Procesamiento del lenguaje natural y redes neuronales"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Definición y fundamentos de NPL"}</span></li>
                <li><span className="fw-light">{"Redes Neuronales definiciones y ejemplos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Inteligencia artificial en diagnóstico médico y medicina por imágenes"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Inteligencia Artificial en diagnóstico médico"}</span></li>
                <li><span className="fw-light">{"IA en medicina por imágenes y Machine Visión"}</span></li>
            </ul>
            <br /><br />
            <b>{"Inteligencia artificial en disciplinas clínico-quirúrgicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"IA en medicina clínica"}</span></li>
                <li><span className="fw-light">{"IA en emergencias"}</span></li>
                <li><span className="fw-light">{"IA en cirugía"}</span></li>
                <li><span className="fw-light">{"IA en oncología"}</span></li>
            </ul>
            <br /><br />
            <b>{"Inteligencia artificial en investigación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"IA en investigación científica"}</span></li>
                <li><span className="fw-light">{"IA en desarrollo de drogas y ciencias básicas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Desarrollo de proyectos en inteligencia artificial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Requisitos"}</span></li>
                <li><span className="fw-light">{"Estructuración de equipo"}</span></li>
                <li><span className="fw-light">{"Pasos a seguir"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaIAMedica;
